import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import {
  Box,
  Button,
  Divider,
  MenuItem,
  Modal,
  TextField,
  Typography
} from '@mui/material';

import LoadingButton from '../../../../../components/buttons/Button';

import {
  UpdateStagingDocumentBIZcoreTD
} from '../../../../../redux/actions/business/core/stagingDocumentsActions';

import global from "../../../../../global.scss";

const MODES = { EDIT: 2 };

const Data = {
  ExtractionStatus: "",
  CompletenessPct: "",
  HasError: false,
};

const EXTRACTION_STATUS_OPTIONS = [
  "PENDING",
  "PROCESSING",
  "COMPLETED",
  "FAILED",
  "SKIPPED",
];

const StagingDocumentsModal = ({
  open,
  setOpen,
  title,
  update,
  handleGet
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(Data);
  const [mode, setMode] = useState(MODES.EDIT);

  const handleClose = () => {
    setOpen(false);
    setFormData(Data);
    setMode(MODES.EDIT);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    try {
      if (open) {
        if (update.defaultMode === MODES.EDIT) {
          setMode(MODES.EDIT);
          setFormData({
            ExtractionStatus: update.extraction_status || "",
            CompletenessPct: update.completeness_pct ?? "",
            HasError: update.has_error !== undefined ? update.has_error : false,
          });
        } else {
          toast.error("Invalid modal");
          handleClose();
        }
      }
    } catch (err) {
      console.log(err);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleSubmit = () => {
    const obj = {
      extraction_status: formData.ExtractionStatus || null,
      completeness_pct: formData.CompletenessPct !== "" ? Number(formData.CompletenessPct) : null,
      has_error: formData.HasError,
    };
    if (mode === MODES.EDIT) {
      dispatch(UpdateStagingDocumentBIZcoreTD(update.id, obj, setLoading)).then(() => {
        handleGet(setLoading).then(() => {
          handleClose();
        });
      });
    } else {
      toast.error("Invalid modal");
      handleClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box className="flexCenterCenterRow" width={"100vw"} height={"100vh"}>
        <Box maxWidth={"sm"} className="modal">
          <Box width={"100%"} sx={{ padding: "15px" }}>
            <Typography variant='h6'
              sx={{ color: global["primary"] }} mb={"20px"}>
              {title}
            </Typography>

            {/* Extraction Status */}
            <Box mb={"15px"}>
              <TextField
                select
                label="Extraction status"
                fullWidth
                name="ExtractionStatus"
                value={formData.ExtractionStatus}
                onChange={handleChange}
              >
                <MenuItem value="">—</MenuItem>
                {EXTRACTION_STATUS_OPTIONS.map((opt) => (
                  <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                ))}
              </TextField>
            </Box>

            {/* Completeness % */}
            <Box mb={"15px"}>
              <TextField
                label="Completeness %"
                fullWidth
                name="CompletenessPct"
                type="number"
                inputProps={{ min: 0, max: 100 }}
                value={formData.CompletenessPct}
                onChange={handleChange}
              />
            </Box>

            {/* Has Error */}
            <Box mb={"15px"}>
              <TextField
                select
                label="Has error"
                fullWidth
                name="HasError"
                value={formData.HasError}
                onChange={handleChange}
              >
                <MenuItem value={true}>Yes</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </TextField>
            </Box>
          </Box>
          <Divider sx={{ backgroundColor: "rgba(44, 45, 47, 1)" }} />
          <Box className="flexCenterFERow" sx={{ gap: "20px", margin: "15px" }}>
            <Button variant='text' onClick={handleClose}>
              Cancel
            </Button>
            <LoadingButton
              variant='contained'
              loading={loading}
              onClick={handleSubmit}>
              Submit
            </LoadingButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default StagingDocumentsModal;
